export const firstTableData = [
  {
    title: "Name",
    value: "Timothy Carlson",
  },
  {
    title: "Number",
    value: "**** 2104",
  },
  {
    title: "Expires",
    value: "12/2024",
  },
  {
    title: "Type",
    value: "Paypal credit card",
  },
  {
    title: "Issuer",
    value: "ENBANK",
  },
  {
    title: "ID",
    value: "w2r84jdy723",
  },
];

export const secondTableData = [
  {
    title: "Billing address",
    value: "USA",
  },
  {
    title: "Phone",
    value: "No phone provided",
  },
  {
    title: "Email",
    value: "uilib@gmail.com",
  },
  {
    title: "Origin",
    value: "United State",
  },
  {
    title: "CVC check",
    value: "Passed",
  },
];
